import { Injectable } from '@angular/core';
import { IDefaultPriceMargin } from '../../dtos/default-price-margin';
import { BaseService } from '../base';
import { IQueryStringFilter } from '../../filters';
import { ContextService, XenaClient } from 'src/app/services';

@Injectable({
  providedIn: 'root'
})
export class DefaultPriceMarginService extends BaseService<IDefaultPriceMargin, IQueryStringFilter> {
  constructor(xenaClient: XenaClient, context: ContextService) {
    super(xenaClient, context, 'DefaultPriceMargin');
  }
}
